/* USP band: decide whether it marquees by MEASURING, not by breakpoint.

   Four items fit one row only while their natural total plus gaps is under the
   container width. With the unified copy that is 748 against 720 at tablet, so
   tablet marquees - but the breakpoint is derived, so if the copy changes the
   decision changes with it rather than staying wrong at a hard-coded 768.

   Speed is constant across widths: the duration is set from the set width at a
   fixed px/second, so a wider track takes proportionally longer rather than
   moving faster. ~28px/s puts a full cycle at roughly 27s on mobile and 31s on
   tablet.

   prefers-reduced-motion: the class is never added, so the band stays a static
   row and the first items are simply visible. */
(function () {
  var PX_PER_SECOND = 28;

  function setup(band) {
    var viewport = band.querySelector('[data-ob-usp-viewport]');
    var track = band.querySelector('[data-ob-usp-track]');
    var set = band.querySelector('[data-ob-usp-set]');
    if (!viewport || !track || !set) return;

    var reduced = window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function measure() {
      // Width the FIRST set NEEDS, and the space it has. The set is a flex
      // child, so reading it in place returns the width it was shrunk to -
      // which equals the container every time, and the marquee never engages.
      // `.ob-usp--measuring` releases it to max-content for the measurement.
      band.classList.remove('ob-usp--marquee');
      // AVAILABLE IS READ FIRST. Releasing the track to max-content widens the
      // viewport itself, so reading clientWidth afterwards returns the widened
      // value and natural always equals available - which is exactly what
      // stopped the marquee engaging.
      var available = viewport.clientWidth;
      band.classList.add('ob-usp--measuring');
      var natural = Math.ceil(set.getBoundingClientRect().width);
      band.classList.remove('ob-usp--measuring');
      var overflows = natural > available + 1;

      if (overflows && !reduced) {
        band.classList.add('ob-usp--marquee');

        // ONE CYCLE IS THE SET WIDTH **PLUS THE GAP BETWEEN THE TWO SETS**.
        // Translating by the set width alone leaves the second set displaced by
        // exactly that gap when the animation restarts, so every cycle jumped
        // 40px at tablet and 28 at mobile - and at the jump the first item
        // landed mid-word with its icon off-screen. Measured, not assumed:
        // set1's right edge to set2's left edge is the track's column-gap.
        var gap = parseFloat(window.getComputedStyle(track).columnGap) || 0;
        var period = natural + gap;

        var seconds = Math.round(period / PX_PER_SECOND);
        track.style.setProperty('--ob-usp-duration', seconds + 's');
        track.style.setProperty('--ob-usp-distance', period + 'px');
      } else {
        track.style.removeProperty('--ob-usp-duration');
        track.style.removeProperty('--ob-usp-distance');
      }
      band.setAttribute('data-ob-usp-natural', natural);
      band.setAttribute('data-ob-usp-available', available);
    }

    measure();
    var t;
    window.addEventListener('resize', function () {
      window.clearTimeout(t);
      t = window.setTimeout(measure, 150);
    });
    // fonts land after first paint and change the natural width
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(measure);
    }
  }

  function init() {
    document.querySelectorAll('.ob-usp').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
